import React from 'react';
import { view } from '@risingstack/react-easy-state';

import './HeaderBarCaption.scss';

export default view((props) => (
  <div className={"header-bar-caption "+(props.red ? 'red ' : '' + (props.className ? props.className : ''))}>{props.children}</div>
));
